import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { SportComplex } from '@/types/playground';
import * as api from '@/lib/api';

interface CentersState {
  items: SportComplex[];
  selected: SportComplex | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: CentersState = {
  items: [],
  selected: null,
  isLoading: false,
  error: null,
};

export const fetchCenters = createAsyncThunk('centers/fetchAll', async () => {
  const centers = await api.getCenters();
  return centers;
});

const centersSlice = createSlice({
  name: 'centers',
  initialState,
  reducers: {
    setCenters: (state, action: PayloadAction<SportComplex[]>) => {
      state.items = action.payload;
    },
    setSelectedCenter: (state, action: PayloadAction<SportComplex | null>) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCenters.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCenters.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(fetchCenters.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Ошибка загрузки спорткомплексов';
      });
  },
});

export const { setCenters, setSelectedCenter } = centersSlice.actions;
export default centersSlice.reducer;






